import React, { FC, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { LinearProgress } from "@evergis/ui";

import {
  SmallPreviewContainer,
  SmallPreviewCounter,
  SmallPreviewImages,
  SmallPreviewLeft,
  SmallPreviewRight,
} from "../styled";
import { SmallPreviewProps } from "../types";

export const SmallPreview: FC<SmallPreviewProps> = ({
  images,
  totalCount,
  currentIndex,
  isLoading,
  setCurrentIndex,
  onClick,
  onNextPage,
}) => {
  const { t } = useTranslation("featureCard");
  const [prevIndex, setPrevIndex] = useState(currentIndex + 1);
  const isPrevDisabled = currentIndex === 0;
  const total = totalCount || images?.length || 0;
  const isNextDisabled = currentIndex === total - 1;

  const prev = useCallback(() => {
    if (isPrevDisabled) return;

    setPrevIndex(currentIndex);
    setCurrentIndex(currentIndex - 1);
  }, [currentIndex, isPrevDisabled, setCurrentIndex]);

  const next = useCallback(() => {
    if (isNextDisabled) return;

    setPrevIndex(currentIndex);
    setCurrentIndex(currentIndex + 1);

    if (currentIndex === images.length) {
      onNextPage();
    }
  }, [currentIndex, images, isNextDisabled, onNextPage, setCurrentIndex]);

  return (
    <SmallPreviewContainer currentIndex={currentIndex + 1} prevIndex={prevIndex + 1}>
      {isLoading && <LinearProgress />}
      {images.length > 1 && (
        <>
          <SmallPreviewLeft $isDisabled={isPrevDisabled} onClick={prev} />
          <SmallPreviewRight $isDisabled={isNextDisabled} onClick={next} />
          <SmallPreviewCounter>
            <div>
              {currentIndex + 1} {t("of")} {total}
            </div>
          </SmallPreviewCounter>
        </>
      )}
      <SmallPreviewImages onClick={onClick}>
        {images.map(image => (
          <img key={image.src} src={image.src} alt="" />
        ))}
      </SmallPreviewImages>
    </SmallPreviewContainer>
  );
};
